import { gql } from '@apollo/client';

export const fetchEntitlementTotalCount = gql`
  query fetchEntitlementTotalCount($id: ID!, $searchOptions: ConnectionSearchOptions, $filterOptions: [FilterOption]) {
    transactionAccount(id: $id) {
      id
      productSubscriptionsInPPC(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
      }
    }
  }
`;
